import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { useExperience } from '../../contexts/ExperienceContext';
import { needs } from '../../data/needs';
import { Advance } from '../ui/Advance';
import { RevealText, Stage } from '../ui/Stage';
const ease = [0.16, 1, 0.3, 1] as const;
const scatter = [{
  x: -180,
  y: -60
}, {
  x: 120,
  y: -110
}, {
  x: 200,
  y: 70
}, {
  x: -90,
  y: 120
}, {
  x: 20,
  y: -10
}];

/** The pivot of the whole story. */
export function RevealStage() {
  const {
    next,
    direction,
    accent
  } = useExperience();
  const [phase, setPhase] = useState(0);
  useEffect(() => {
    const timers = [window.setTimeout(() => setPhase(1), 2600), window.setTimeout(() => setPhase(2), 3900)];
    return () => timers.forEach(window.clearTimeout);
  }, []);
  return <Stage direction={direction} className="min-h-screen items-center py-28 text-center sm:py-32" labelledBy="reveal-title" data-id="element-338" data-mp="2kp7fe3hka3xu">
      {/* Five solutions converging into one family */}
      <div className="pointer-events-none relative mb-14 h-40 w-full max-w-xl sm:h-52" data-id="element-339" data-mp="1i8cy2d2knf9h">
        {needs.map((need, index) => <motion.span key={need.id} className="absolute left-1/2 top-1/2 h-36 w-36 rounded-full blur-[38px] sm:h-44 sm:w-44" style={{
        backgroundColor: need.accent
      }} initial={{
        x: scatter[index].x - 72,
        y: scatter[index].y - 72,
        opacity: 0,
        scale: 0.7
      }} animate={{
        x: (index - 2) * 34 - 72,
        y: -72,
        opacity: 0.42,
        scale: 1
      }} transition={{
        duration: 2,
        delay: 0.15 + index * 0.16,
        ease
      }} data-id="element-340" data-mp="1d7z0joyljnpp" data-mpi={index} />)}
        <motion.span className="absolute left-1/2 top-1/2 h-px w-64 -translate-x-1/2 bg-enamel/25" initial={{
        scaleX: 0
      }} animate={{
        scaleX: 1
      }} transition={{
        duration: 1.4,
        delay: 1.4,
        ease
      }} data-id="element-341" data-mp="gj9d7j47a2wc" />
      </div>

      <h2 id="reveal-title" className="display-tight max-w-4xl text-display font-light" data-id="element-342" data-mp="1viuuqmoxyxo">
        <span className="block text-enamel/45" data-id="element-343" data-mp="5zywgfp9uk73">
          <RevealText text="You may not need a better composite." delay={0.3} data-id="element-344" data-mp="3o4aexf3mc8td" />
        </span>
        <span className="mt-3 block text-enamel sm:mt-5" data-id="element-345" data-mp="3t2vct7veegen">
          <RevealText text="You may need a better family." delay={1.5} data-id="element-346" data-mp="3t3djkyfosd0t" />
        </span>
      </h2>

      <AnimatePresence data-id="element-347" data-mp="ko3jtwz9rjw7">
        {phase >= 1 && <motion.div initial={{
        opacity: 0,
        y: 22
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.9,
        ease
      }} className="mt-16 flex max-w-2xl flex-col items-center gap-6 border-t border-enamel/10 pt-12" data-id="element-348" data-mp="pmwl8r1a7kg0">
            <p className="text-lede font-light text-enamel" data-id="element-349" data-mp="13m62lu184klk">
              Different clinical situations demand different things.
            </p>
            <p className="max-w-xl text-base font-light leading-relaxed text-mute" data-id="element-350" data-mp="18dxss3ggwob6">
              Rather than asking one material to do everything, the Filtek Family gives clinicians
              different solutions within one restorative ecosystem.
            </p>
            {phase >= 2 && <div className="mt-6" data-id="element-351" data-mp="31uk4w4qaxo8h">
                <Advance label="See the logic" onClick={next} accent={accent} align="center" delay={0.1} data-id="element-352" data-mp="31xpox5k2pzxc" />
              </div>}
          </motion.div>}
      </AnimatePresence>
    </Stage>;
}